<template>
	<div class="Business">
		<div class="banner">
			<div class="content">
				<div class="content_2">
					<div class="banner_img">
						<img src="../assets/Business.png" />
					</div>
				</div>
			</div>
		</div>
		<div class="tz borb1 hidden-xs-only" style="background-color: #f2f5f7;">
			<div class="dib tabs" @mouseleave="activeTab = routerTab">
				<el-tabs v-model="activeTab">
					<template v-for="(item, i) in items">
						<el-tab-pane :name="item.tab">
							<template #label>
								<div class="tab" @mouseenter="mousemove(item.tab)" @click="link(item.tab)">{{item.name}}</div>
							</template>
						</el-tab-pane>
					</template>
				</el-tabs>
			</div>
		</div>
		<div class="Business_content">
			<div class="content">
				<!-- <div class="content_2"> -->
					<el-row>
						<!-- <el-col :span="5" class="hidden-xs-only">
							<div class="Business_tab" ref="tab">
								<div class="Business_item bet oh" v-for="(item, i) in items" :key="i" :class="{'Business_item_active': activeTab == item.tab}" @click="link(item.tab)">
									<div class="fl f16">{{item.name}}</div>
									<div class="fr pr t2"><i class="el-icon-arrow-right"></i></div>
								</div>
							</div>
						</el-col>
						<el-col :span="1"></el-col> -->
						<el-col :span="24"><!-- :xs="24" :sm="18" :md="18" :lg="18" :xl="18" -->
							<div class="Business_Box">
								<div class="view">
									<div class="tz pt20 bff show-xs-only">
										<div class="vf7" style="margin: 0 2vw 20px;">{{items.filter(x => x.tab == routerTab)[0].name}}</div>
										<div class="f16" style="margin: 0 2vw;">{{items.filter(x => x.tab == routerTab)[0].en.toUpperCase()}}</div>
									</div>
									<div class="pt30 plr30 lh7 tz hidden-xs-only">
										<div class="f30">{{items.filter(x => x.tab == routerTab)[0].name}}</div>
										<div class="f20">{{items.filter(x => x.tab == routerTab)[0].en.toUpperCase()}}</div>
									</div>
									<router-view @look="look"></router-view>
								</div>
								<div class="Business_foot yy"></div>
							</div>
						</el-col>
					</el-row>
				<!-- </div> -->
			</div>
		</div>
		<el-dialog title="" v-model="dialogShow" destroy-on-close width="1200px" :show-close="false"
			:close-on-click-modal="true" @open="$opened(this)">
			<div class="window" :class="[dialogType+'_window']">
				<div class="tz borb1">
					<div class="f30 b c3">{{dialog.title}}</div>
					<div class="f14 c9 ptb20">发布日期： {{dialog.date}}</div>
				</div>
				<div class="img tz mtb20">
					<img :src="dialog.img" style="max-width: 100%;" />
				</div>
				<div class="window_content" v-html="dialog.html"></div>
				<div class="close bluebg" @click="dialogShow = false">
					<i class="el-icon-close"></i>
				</div>
			</div>
		</el-dialog>
	</div>
</template>

<script>
	import Business from './components/Head.vue';
	export default {
		data() {
			return {
				items: [],
				activeTab: 'WLGHZX',
				routerTab: 'WLGHZX',
				show: true,
				dialog: {},
				top: 0,
				dialogShow: false,
				dialogType: ''
			}
		},
		created() {
			this.items = Business.data().tabs.filter(x => x.tab == 'Business')[0].dropdown;
			this.activeTab = this.$route.name;
		},
		watch: {
			'$store.state.link'() {
				this.$nextTick(() => {  //页面加载完成后执行
					if (this.$route.fullPath.includes('Business')) {
						this.initTab();
						// document.body.scrollTop = document.documentElement.scrollTop = this.$store.state.mobile ? 0 : 460;
					}
				})
			}
		},
		mounted() {
			this.initTab();
		},
		unmounted() {
			
		},
		methods: {
			mousemove(activeTab) {
				this.activeTab = activeTab
			},
			initTab() {
				this.$nextTick(() => {
					this.items.forEach(x => {
						if (this.$route.href.includes(x.tab)) {
							this.routerTab = this.activeTab = x.tab
						}
					})
				})
			},
			link(tab) {
				this.routerTab = tab;
				this.activeTab = tab;
				this.$router.push({name: tab})
			},
			look(item, type) {
				this.dialogType = type;
				this.dialogShow = true;
				this.dialog = item;
			}
		}
	}
</script>

<style lang="scss">
	@import '@/assets/css/theme.scss';
	.Business {
		@media screen and (max-width: 768px) {
			overflow: hidden;
		}
		.banner {
			height: 360px;
			position: relative;
			background: url(../assets/About_banner_ZZJG.jpg) no-repeat center;
			z-index: -1;
			
			@media screen and (max-width: 768px) {
				height: 220px;
				background-size: cover;
				margin-bottom: 0;
			}
		}
		
		.el-tabs__nav-wrap {
			&::after {
				display: none;
			}
		
			.tab {
				font-size: 16px;
				color: #333333;
				line-height: 40px;
				cursor: pointer;
			}
		}
		
		.el-tabs__item {
			padding: 0 55px;
			position: relative;
		
			&::after {
				position: absolute;
				content: ' ';
				width: 1px;
				height: 15px;
				background-color: #444;
				right: 0;
				top: 12px;
			}
		
			&:last-of-type {
				&::after {
					display: none;
				}
			}
		
			&:hover {
				cursor: default;
			}
		}
		
		.el-tabs__header {
			margin: 0;
		}
		
		.tabs {
			margin: 10px 0;
		}
		
		.Business_content {
			padding: 75px 0;
			background: url(../assets/Business_2.jpg) repeat-y top center;
			// background-size: cover;
			@media screen and (max-width: 768px) {
				padding: 65px 4vw;
				padding: 0;
				box-sizing: border-box;
			}
			.Business_tab {
				position: -webkit-sticky;
				position: sticky;
				top: 75px;
			}
		}
		.Business_Box {
			position: relative;
			// height: 800px;
			// height: calc(100vh - 150px);
			
			.Business_foot {
				position: absolute;
				left: 0;
				top: 0;
				bottom: 0;
				right: 0;
				background-color: #FFFFFF;
				@media screen and (max-width: 768px) {
					display: none
				}
			}
			
			.view {
				position: relative;
				z-index: 10;
				height: 100%;
				box-sizing: border-box;
				// overflow: auto;
				
				@media screen and (max-width: 768px) {
					.p30 {
						padding: 0!important;
						background-color: #fff;
					}
					
					.view_title {
						text-align: center;
						font-size: 20px;
						// font-weight: bold;
						letter-spacing: 2px;
						line-height: 1.2;
						text-align: center;
						margin: 24px auto;
						width: 80%;
					}
				}
				
				.item {
					padding: 24px;
					box-sizing: border-box;
					border-radius: 2px;
					margin-bottom: 30px;
					cursor: pointer;
					
					.hang2 {
						height: 56px;
					}
				
					.info {
						line-height: 2;
					}
				
					img {
						transition: all 0.3s;
						-webkit-transition: all 0.3s;
					}
				
					&:hover {
						box-shadow: 0 0 30px #d7d7d7;
				
						.bred {
							color: $blue;
						}
				
						img {
							transform: scale(1.05);
						}
					}
					
					@media screen and (max-width: 768px) {
						border-bottom: 1px solid #E6E6E6;
						border-radius: 0px;
						&:hover {
							box-shadow: none;
						}
						&:last-of-type {
							margin-bottom: 0;
						}
					}
				}
				
			}
		}
		.Business_item {
			padding: 20px;
			cursor: pointer;
			transition: all 0.1s;
			width: 90%;
			box-sizing: border-box;
			&.Business_item_active {
				background-color: $blue;
				color: #FFFFFF;
				width: 100%;
			}
			&:hover {
				@extend .Business_item_active;
			}
		}
		
		.window {
			padding: 10px 30px 50px;
			box-sizing: border-box;
			background: #FFFFFF;
			position: relative;
			
			img {
				width: 100%;
			}
		}
		
		.window_content {
			font-size: 16px;
			line-height: 2;
			
			p {
				margin: 0 0 20px;
				// text-indent: 32px;
			}
			
			img {
				width: 100%;
				// max-width: 770px;
				margin: 0 auto;
				display: block;
			}
			
			h2 {
				margin: 0;
				font-size: 16px;
			}
			
			table {
				border-collapse: collapse;
				border-spacing: 0;
				// border-color: #E6E6E6;
				
				tr:nth-child(odd) {
					background-color: #f2f2f2;
				}
				
				// tr:first-of-type {
				// 	background-color: #f0f0f0;
				// }
				
				td {
					padding: 0px 8px;
				}
				
				p {
					margin: 0;
				}
			}
		}
		
		.close {
			position: absolute;
			width: 50px;
			height: 50px;
			right: -70px;
			top: -60px;
			text-align: center;
			cursor: pointer;
			i {
				font-size: 30px;
				color: #FFFFFF;
				line-height: 50px;
			}
		}
		
		.el-dialog {
			max-width: 80%;
			@media screen and (max-width: 768px) {
				max-width: 100%;
			}
		}
	}
</style>
